import type {SchemaReference} from 'schemas/types';
import type {CodeListMap} from 'services/codelists/types';
import type {CodelistRestrictor} from 'services/codelists/contexts/RestrictedCodelistsContext';
import {useRestrictedCodelists} from 'services/codelists/hooks/useRestrictedCodelists';
import {useSchemaCodelistIds} from 'schema/hooks/useSchemaCodelistIds';
import {useSchema} from 'schemas/hooks/useSchema';

export function useRestrictedCodelistsForSchema(
  codelistRestrictor: CodelistRestrictor,
  schemaRef: SchemaReference,
): CodeListMap {
  const schema = useSchema(schemaRef);
  const codelistIds = useSchemaCodelistIds(schema);
  return useRestrictedCodelists(codelistRestrictor, codelistIds);
}
